import { forwardRef } from "react";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

import {
  COLLAPSIBLE_DEFAULTS,
  type TCollapsibleTriggerElement,
  type TCollapsibleTriggerProps,
} from "@/ui/components/data-display/Collapsible/Collapsible.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";
import { TextSubtitle } from "../../typography/TextSubtitle";

export const CollapsibleTrigger = forwardRef<TCollapsibleTriggerElement, TCollapsibleTriggerProps>(
  (
    {
      children,
      className,
      triggerIcon = COLLAPSIBLE_DEFAULTS.triggerIcon,
      ...props
    },
    ref,
  ) => (
    <CollapsiblePrimitive.Trigger
      data-component="CollapsibleTrigger"
      ref={ref}
      className={cn(
        "group flex w-full items-center justify-between gap-3 px-4 text-left",
        "transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-primary",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <TextSubtitle
        tag="div"
        size={3}
        isResponsive={false}
        className="min-w-0 flex-1"
      >
        { children }
      </TextSubtitle>
      <div className="w-9 h-9 flex justify-center items-center">
        <Icon
          data-component="CollapsibleTriggerIcon"
          icon={triggerIcon}
          aria-hidden="true"
          size="sm"
        />
      </div>
    </CollapsiblePrimitive.Trigger>
  ),
);

CollapsibleTrigger.displayName = CollapsiblePrimitive.Trigger.displayName;
